export default __webpack_public_path__ + "static/media/logo.741e0997.svg";